import angular from 'angular';
import ngfilter from 'angular-filter';

import itemService from '../../services/item.service';
import itemorderService from '../../services/itemorder.service';
import itemorderController from './itemorder.controller';
import itemorderModalController from './itemorderModal.controller';

export default angular.module('components.itemorder', [
    'angular.filter',
    itemorderService,
    itemService
])
    .component('itemorder', {
        template: require('./itemorder.pug')(),
        bindings: {
            text: '@',
            docid: '<',
            opacrecord: '<',
            onDone: '&',
            disabled: '<'
        },
        controller: itemorderController
    })
    .component('itemorderModal', {
        template: require('./itemorderModal.pug')(),
        bindings: {
            modalInstance: '<',
            resolve: '<'
        }, 
        controller: itemorderModalController
    })
    .value('ItemorderConfig', {
        catalogid: 1,
        desks: [
            {nuc:'НТБ_ТПУ', loc: "НФ", desk:"АНЛ"},
            {nuc:'НТБ_ТПУ', loc: "НФ", desk:"ЧЗТЛ"},
            {nuc:'НТБ_ТПУ', loc: "РФ", desk:"ОРКиР"},
            {nuc:'НТБ_ТПУ', loc: "РФ", desk:"ЧЗТЛ"},
            {nuc:'НТБ_ТПУ', loc: "УФ", desk:"АУЛ"},
            {nuc:'НТБ_ТПУ', loc: "ХФ", desk:"АХЛ"}
        ]
    })
    .name; 
